import React from "react";
import Cookie from "js-cookie";
import { Row, Col } from "react-bootstrap";
import DataTable from "react-data-table-component";
import LoadingOverlay from "react-loading-overlay";

import axios from "../../../service/axios";
import * as Constants from "../../../constants/Constants";
import TeamRenderer from "./Renderers/TeamRenderer";
import AssignRenderer from "./Renderers/AssignRenderer";

class NewVendors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pipeLineOwner: {},
      selectedRowId: 0,
      noDataComponent: "No New Vendor available",
    };
  }

  componentWillUnmount() {
    this.props.resetValue();
  }

  onTeamChange = (selectedPipeLineOwner, rowId) => {
    this.setState({
      selectedRowId: rowId,
      pipeLineOwner: selectedPipeLineOwner,
    });
  };

  onAssignChange = (selectedVendor) => {
    const { pipeLineOwner } = this.state;
    const headerData = {
      vendorDetail: {
        plOwnerShip: pipeLineOwner.emailId,
        plOwnerShipName: pipeLineOwner.userName,
        id: selectedVendor && selectedVendor.id,
        lastUpdatedBy: Cookie.get("email")
          ? Cookie.get("email").toLowerCase()
          : "",
      },
    };

    axios()
      .post("/vendorProfile/saveAssignedVendor/", headerData)
      .then((response) => {
        const { data = {}, status } = response || {};
        const { id = "" } = data || {};
        if (status === 200 && data && data.id && data.id !== "") {
          this.props.removedVendor(id);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const columns = [
      {
        name: "Name",
        selector: "vendorCorpName",
      },
      {
        name: "Vendor Fulfillment Type",
        selector: "merchandiseType",
      },
      {
        name: "Platform",
        selector: "vendorConnectionPlatForm",
      },
      {
        name: "Team",
        button: true,
        width: "250px",
        cell: (row) => (
          <TeamRenderer
            rowId={row.id}
            selectedRowId={this.state.selectedRowId}
            pipeLineOwner={this.state.pipeLineOwner}
            pipeLineOwnerList={this.props.pipeLineOwnerList}
            onTeamChange={this.onTeamChange}
          />
        ),
      },
      {
        name: "Assign",
        button: true,
        cell: (row) => (
          <AssignRenderer
            row={row}
            selectedRowId={this.state.selectedRowId}
            onAssignChange={this.onAssignChange}
          />
        ),
      },
    ];

    return (
      <div className="newVendor">
        <LoadingOverlay active={this.props.isMyNewVendorLoading} spinner>
          <Row className="myTeamTitle">{Constants.NEW_VENDORS}</Row>
          <div className="newVendorTable">
            <DataTable
              columns={columns}
              data={this.props.newVendor}
              noDataComponent={this.state.noDataComponent}
              noHeader
            />
          </div>
        </LoadingOverlay>
      </div>
    );
  }
}

export default NewVendors;
